<template>
	<div class="header pt-1" id="home">
		<div class="container">
			<!-- هدر وقتی وارد شده باشد -->
			<ul class="dir-rtl mt-2 pr-0 mb-0" v-if="auth.login">
				<li style="vertical-align: bottom;width:50% !important">
					<div id="sideMenuTempSign" @click="getSideMenu">
						<div class="humber"></div>
						<div class="humber"></div>
						<div class="humber"></div>
					</div>
				</li>
				<li class="my-brand" style="width:50% !important">
					<h2 class="text-end mb-0">RADAP </h2>
				</li>
				<li style="width:33% !important">
					<button class="no-effect-button align-center " type="button" data-bs-toggle="modal"
						data-bs-target="#StoreModal" style="font-size: 15px;">
						<span>{{ city }}</span>
						<i class="bi bi-chevron-down" aria-hidden="true" style="vertical-align: middle;"></i>
					</button>
				</li>
				<li class="header-li header-score text-center"
					style="width:33% !important;font-weight: 600;font-size: 14px;" @click="goScoreAccount">
					<Transition>
						<span v-if="show">
							<i :class="auth.head.score.icon" aria-hidden="true"></i>
							{{ convertToPersian(auth.head.score.value) }}
						</span>
					</Transition>
					<span v-if="!show">
						<i :class="auth.head.score.icon" aria-hidden="true"></i>
						{{ convertToPersian(auth.head.score.value) }}
					</span>
				</li>

				<li style="width:33% !important;text-align: end;" @click="goWalletAccount">
					<button :disabled="auth.head.wallet.disabled">
						<i :class="auth.head.wallet.icon" aria-hidden="true"></i> {{
							convertToPersian(numberFormat(auth.head.wallet.value)) }}
					</button>
				</li>
			</ul>
			<!-- هدر وقتی وارد نشده باشد -->
			<ul class="dir-rtl py-2 ps-0 mb-0 " v-else>
				<li style="vertical-align: middle;" class="header-mobile-none">
					<div @click="getSideMenu()" id="sideMenuTemp">
						<div class="humber"></div>
						<div class="humber"></div>
						<div class="humber"></div>
					</div>
				</li>
				<li class="header-mobile-none my-brand">
					<h2 class="text-center mb-0"> RADAP </h2>
				</li>
				<li class="text-end header-mobile-none sign-info">
					<button><span @click="goAccountPage(1)">ورود</span>|<span @click="goAccountPage(2)">ثبت
							نام</span></button>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>

import { reactive, ref } from '@vue/reactivity'
import { useRouter } from 'vue-router';
import { removeCommos, numberFormat, convertToPersian } from '@/composables/digits';
import { useAuth } from '@/store/auth'
let auth = useAuth()
let city = ref('تربت جام')
let show = ref(false)
let router = useRouter()
auth.getAuth()
function goAccountPage(type) {
	if (type == 1) {
		document.querySelector('#loginsModalBTN').click()
	} else {
		document.querySelector('#mobileModalBTN').click()
	}
}
function getSideMenu() {
	document.querySelector('#sideMenuModalBTN').click()
}
function goWalletAccount() {
	router.push({ name: 'Account', hash: '#credit' })
}
function goScoreAccount() {
	router.push({ name: 'Account', hash: '#score' })
}
</script>
<style scoped>
.header ul li {
	text-align: start;
	width: 33%;
}

.header-li-brand {
	display: none;
}

@media (min-width: 644px) {
	.header-mobile {
		display: none !important;
	}
}

@media (min-width: 644px) {
	.header-mobile-none {
		width: 33% !important;
	}
}

.header-location {
	/* width: 100% !important; */
	white-space: nowrap;
	overflow: hidden;
	vertical-align: middle;
}

@media (max-width: 776px) {

	.header ul li {
		padding: 0;
		width: 33%;
	}

	/* .header-score{
		text-align: end !important;
	} */
	.header-basket {
		display: none;
	}

	.header-location i {
		margin-right: 0;
	}

	.header-mobile {
		display: inline-block !important;
	}

}

.my-brand h2 {
	color: red;
	font-size: 22px;
	font-family: Adera !important;
}

.humber {
	width: 26px;
	height: 2px;
	background-color: #d5d5d5;
	margin: 5px 0;
}

.header {
	background: #fff;
}

.humber {
	background-color: black !important;
}

.user-info * {
	color: black !important;
}

.sign-info * {
	color: black !important;
}

.v-enter-active,
.v-leave-active {
	transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}
</style>
